import { useTranslation } from '@shared/core';

const TRACK_IDS = ['celestial-harp', 'morning-piano', 'soothing-strings'] as const;

/** Resolves a stored `musicId` to its audio URL without loading the admin translations the picker needs. */
export const getDigitalCardMusicUrl = (musicId: string | undefined) =>
  musicId && (TRACK_IDS as ReadonlyArray<string>).includes(musicId) ? `https://withjoy.blob.core.windows.net/paper-music/${musicId}.mp3` : undefined;

/** Catalog with localized labels for the music picker. */
export const useDigitalCardMusic = () => {
  const { tq } = useTranslation('stationery');
  const labels: Record<(typeof TRACK_IDS)[number], string> = {
    'celestial-harp': tq`Celestial Harp`,
    'morning-piano': tq`Morning Piano`,
    'soothing-strings': tq`Soothing Strings`,
  };

  return TRACK_IDS.map(id => ({ id, label: labels[id], url: getDigitalCardMusicUrl(id) }));
};
